import React from "react";
import LegalLayout from "../../layouts/LegalLayout/LegalLayout";
import styles from "./Legal.module.scss";

const IssuerInternationalPrivacyPolicy = () => {
  return (
    <LegalLayout title="STBL Card Terms (International)">
      <div className={styles.legalContent}>
        <section className={styles.section}>
          {/* <h2>STBL CARD TERMS (INTERNATIONAL)</h2> */}
          <h3>STBL CARDHOLDER AGREEMENT</h3>
          <p className={styles.lastUpdated}>Last Updated: 5/13/2026</p>

          <div className={styles.importantNote}>
            <p>
              <strong>Arbitration Clause; Notices</strong>
            </p>
            <p>
              PLEASE REVIEW THE ARBITRATION CLAUSE AND NOTICES SET FORTH BELOW IN
              THE SECTION TITLED DISPUTE RESOLUTION AND ARBITRATION. BY USING THE
              STBL CARD, YOU ARE AGREEING TO THE ARBITRATION CLAUSE AND NOTICES SET
              FORTH IN THAT SECTION. THE ARBITRATION CLAUSE WILL HAVE A SUBSTANTIAL
              EFFECT ON YOUR RIGHTS IN THE EVENT OF A DISPUTE, INCLUDING YOUR RIGHT
              TO BRING OR PARTICIPATE IN A CLASS PROCEEDING.
            </p>
          </div>

          <p>
            This STBL Card Cardholder Agreement (&ldquo;Agreement&rdquo;) is a
            binding agreement between you (&ldquo;you&rdquo; or &ldquo;your&rdquo;)
            and the Issuer (&ldquo;we&rdquo;, &ldquo;us,&rdquo; or &ldquo;our&rdquo;)
            that governs your use of the card account (&ldquo;Account&rdquo;) and
            STBL Card (&ldquo;STBL Card&rdquo; or &ldquo;Card&rdquo;).
          </p>
          <p>
            The STBL Card is provided to you on behalf of STBL in connection with your
            status as STBL customer and pursuant to your separate User Agreement
            between you and STBL (the &ldquo;User Terms&rdquo;).
          </p>
          <p>
            We are not a party to the User Terms and disclaim any liability for the
            performance of services covered therein.
          </p>
          <p>
            In the event of any conflict between this Agreement and the User Terms,
            this Agreement shall be controlling.
          </p>

          <h3>Eligibility</h3>
          <p>By applying for or using the STBL Card, you represent and warrant that:</p>
          <ul className={styles.legalList}>
            <li>you are not a U.S. citizen or resident;</li>
            <li>you are not applying for services from within the United States;</li>
            <li>you are legally permitted to use the Card in your jurisdiction; and</li>
            <li>
              your use of the Card complies with applicable local laws and regulations.
            </li>
          </ul>

          <h3>Fees and Charges</h3>
          <table className={styles.disclosureTable}>
            <thead>
              <tr>
                <th>Fee Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.labelCell}>Interest Charges</td>
                <td>0.00%</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>International Transactions</td>
                <td>Up to 3%</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Foreign Exchange Fees</td>
                <td>Up to 3%</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Late Payment Fee</td>
                <td>Up to $40</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Returned Payment Fee</td>
                <td>Up to $29</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Liquidation-Related Fees</td>
                <td>Up to $35</td>
              </tr>
            </tbody>
          </table>
          <p>
            No interest charges currently apply to purchases made using the STBL Card.
          </p>

          <h3>Additional Definitions</h3>
          <p>
            The term &ldquo;Card&rdquo; means any card we issue associated with your
            Account, including renewal and substitute cards. The term
            &ldquo;Card&rdquo; also means any other access device that allows you to
            obtain Account access from us, including your Account number. Other
            capitalized terms that are not defined here are generally defined the first
            time we use those terms.
          </p>
          <p>
            The term &ldquo;Issuer&rdquo; refers to Third National, including its
            affiliates, successors, and assigns.
          </p>
          <p>
            The term &ldquo;Supported Blockchain&rdquo; means the Ethereum Blockchain,
            Polygon Blockchain, Optimism Blockchain, Arbitrum Blockchain and other
            blockchain networks. We may update this list of Supported Blockchains at
            any time and at our sole discretion.
          </p>
          <p>
            The terms &ldquo;you&rdquo; and &ldquo;your&rdquo; mean each and all of the
            persons who are granted, accept or use the Account and any person who has
            guaranteed payment of the Account.
          </p>

          <h3>Overview of Account Agreement</h3>
          <p>
            We reserve the right to amend this Agreement or impose additional
            obligations or restrictions on you at any time with or without notice to
            you, except where required by applicable law. By continuing to use the
            Cards, you agree to be bound by such amendments or additional obligations
            or restrictions.
          </p>
          <p>
            We will notify you of any amendment to this Agreement by email, in-app
            notification, or posting through the STBL platform.
          </p>
          <p>
            If any amendment to this Agreement allows you to reject such amendment, and
            if you reject the amendment in the manner described in such amendment, we
            may terminate your Account.
          </p>
          <p>
            If an amendment to this Agreement increases the applicable fees or charges
            applicable to your Account, any existing unpaid balances may be subject to
            such increase.
          </p>
          <p>
            You agree that this Agreement becomes effective the first time you use any
            Card or the Account. You agree that you were not solicited for this product.
            You also agree that we may keep and use an image or copy of the Agreement
            to enforce its terms against you.
          </p>
          <p>
            When the Agreement states we &ldquo;may&rdquo; take an action, it means we
            are authorized to take that action in our sole discretion, subject only to
            any limitations or requirements established by law and the express terms of
            the Agreement.
          </p>
          <p>
            Please read this Agreement carefully and keep them for future reference.
          </p>
          <p>
            We may make new offers to you in the future or forward offers from others
            that may interest you. If these offers have new or different terms, those
            terms will be provided with the offer. If you accept the offer, the
            previously disclosed terms in the Agreement will still apply, except as
            modified by the offer.
          </p>
          <p>
            STBL provides technology services in connection with the STBL Card, and is
            not a bank, credit union, or money services business and does not itself
            extend credit, set interest rates, determine repayment terms or hold
            Collateral. Nothing in this Agreement shall be construed as creating a
            lender-borrower relationship between you and STBL.
          </p>
          <p>You acknowledge and agree that STBL:</p>
          <ul className={styles.legalList}>
            <li>
              is an express third-party beneficiary of this Agreement, with the limited
              right to enforce obligations that directly relate to its role;
            </li>
            <li>
              is not responsible for any decisions by the Issuer to approve, decline,
              suspend or close your Card account. STBL may, at the request of the
              Issuer, the payment network or a regulatory authority, suspend or restrict
              your access to the STBL platform or certain features, to protect against
              fraud, comply with applicable laws or manage program risk;
            </li>
            <li>
              does not control and is not responsible for the operation, security, or
              performance of the smart contracts used to hold your Collateral; and
            </li>
            <li>
              is not responsible for merchant acceptance of your STBL Card or for
              resolving disputes about goods or services purchased with the STBL Card.
            </li>
          </ul>
          <h3>Using Your Account and Card</h3>
          <p>
            You may use your Card and the Account for making Purchases and for
            obtaining any Special Offers that we may provide, as permitted by this
            Agreement and applicable law.
          </p>
          <p>
            You agree to sign the Card immediately after you receive it. The Card is
            valid during the dates shown on the front. The Card is our property and you
            agree to return it to us or destroy it, if we ask. You agree to take
            reasonable steps to prevent the unauthorized use of your Card and Account.
          </p>
          <p>
            We are not responsible to you if someone refuses to accept your Card for
            any reason. We may reject any transaction for any reason. We may limit the
            combined dollar amount or the total number of certain Account transactions
            allowed during a single day or other time periods.
          </p>
          <p>
            We may restrict or delay the availability of Account access, to protect you
            and us against potential fraud, unauthorized transactions, Account
            misconduct or misuse, or for other risk management reasons. We will not be
            liable to you if this happens.
          </p>
          <p>
            Except as otherwise required by applicable law or regulation, we will not be
            responsible for merchandise or services purchased or leased through the use
            of any Card or the Account.
          </p>
          <p>
            You agree not to use, try to use, or permit use of the Card or Account for
            any Internet gambling transactions or any other transactions that are
            illegal or not permitted by us. Even if you do, you must still pay us for
            these transactions, and they remain subject to all other terms of our
            Agreement.
          </p>
          <p>
            You must reimburse us for all damages and expenses associated with these
            transactions.
          </p>
          <p>
            You acknowledge and agree that you have read and understood the STBL
            prohibited activities list available at{" "}
            <a
              href="https://www.stbl.io/terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.stbl.io/terms
            </a>{" "}
            and that you will not engage in any such activities when using the Services
            or the STBL Card.
          </p>
          <p>
            From time to time, Account services may be unavailable to you, due to
            circumstances beyond our control, such as system failures, fires, floods,
            natural disasters or other unpredictable events. When this happens, you may
            be unable to use your Card or obtain Account information. We will not be
            responsible or liable to you if this happens.
          </p>

          <h3>Lost or Stolen Cards; Unauthorized Use; Replacement Cards</h3>
          <p>
            You must take reasonable steps to prevent the unauthorized use of your Card
            and Account.
          </p>
          <p>
            If you notice the loss or theft of your Card, or a possible unauthorized use
            of your Card, you should write to us immediately at the address provided on
            your Statement or call us at +1 (385) 600-7758.
          </p>
          <p>
            You may be liable for unauthorized use that occurs before you notify us.
            Your liability may vary depending on applicable law and payment network
            rules.
          </p>
          <p>
            If we reimburse your Account for unauthorized charges made using your Card,
            you agree to help us investigate, pursue and obtain reimbursement from the
            wrongdoer.
          </p>
          <p>
            Your help includes giving us documents that we ask for and that are acceptable
            to us.
          </p>
          <p>
            Unless canceled, a Card will be valid through the expiration date which is
            printed on the Card. We may replace a Card at any time and we may continue to
            issue renewal or replacement Cards until you notify us to cancel the Account.
          </p>
          <p>
            You are responsible for canceling any lost, misused or stolen Cards or the
            Account that you suspect may have been the subject of fraud, unauthorized use
            or misuse.
          </p>
          <p>
            You are responsible for retrieving the canceled Card and destroying it to
            prevent further use.
          </p>
          <p>You may also cancel a Card by calling our customer service center.</p>
          <p>
            All telephone communications by you to us must be made by calling our
            customer service center at +1 (385) 600-7758 as soon as the need arises.
          </p>
          <p>
            You understand that we will require a reasonable amount of time to act on any
            request made by telephone.
          </p>

          <h3>Communications</h3>
          <p>
            By accepting these Card Terms or using your Card, you acknowledge that you
            have received, reviewed, and agree to be bound by the Issuer&rsquo;s E-Sign
            &amp; Electronic Communications Notice (the &ldquo;E-Sign Notice&rdquo;),
            which is incorporated herein by reference.
          </p>
          <p>
            You consent to receive all disclosures, notices, agreements, and other
            communications from Issuer and its service providers in electronic form,
            in accordance with the E-Sign Notice.
          </p>
          <p>
            You agree that such electronic communications satisfy any legal requirement
            that such communications be in writing.
          </p>
          <p>
            The E-Sign Notice may be amended by Issuer from time to time, and your
            continued use of the Card after any such amendment constitutes your acceptance
            of the amended E-Sign Notice.
          </p>
          <p>
            We may contact you from time to time about your Account. We may contact you
            in any manner we choose, unless the law says that we cannot.
          </p>
          <p>For example, we may:</p>
          <ul className={styles.legalList}>
            <li>
              contact you by mail, telephone, email, fax, recorded message, text message
              or personal visit;
            </li>
            <li>
              contact you using an automated dialing or similar device
              (&ldquo;Autodialer&rdquo;);
            </li>
            <li>contact you at your home and at your place of employment;</li>
            <li>contact you on your mobile telephone;</li>
            <li>contact you at any time, including weekends and holidays;</li>
            <li>contact you with any frequency;</li>
            <li>
              leave recorded and other messages on your answering machine/service and with
              others; and
            </li>
            <li>
              identify ourselves, your relationship with us, and our purpose for
              contacting you, even if others might hear or read it.
            </li>
          </ul>

          <h3>Credit Reports</h3>
          <p>
            We may provide information about you and the Account to credit reporting
            agencies or financial information providers. We may also provide information
            about you and the Account to others as described in our Privacy Notices.
          </p>
          <p>
            We may obtain and use credit and income information about you from credit
            reporting agencies and others as the law allows.
          </p>
          <p>
            If you believe we have reported inaccurate information about you to a
            reporting agency, notify us in writing at:
          </p>
          <div className={styles.addressBlock}>
            Card Services
            <br />
            STBL
            <br />
            5513 W. 11000 N, Box 408
            <br />
            Highland, UT 84003
          </div>
          <p>
            In doing so, identify yourself, your Account, the information you believe is
            inaccurate, and tell us why you believe the information is incorrect.
          </p>

          <h3>Closing or Suspending Your Account</h3>
          <p>
            You may ask us to close your Account by calling or writing us as described on
            your Statement.
          </p>
          <p>
            If you do, we may provide you with additional details about this process and
            request certain information from you.
          </p>
          <p>
            If you use your Card or charges post to your Account after you ask us to
            close it, we may keep your Account open or reopen it.
          </p>
          <p>
            We may close or suspend your Account and your right to access card services
            from us. We may do this at any time and for any reason, as permitted by law,
            even if you are not in default.
          </p>
          <p>
            A suspension of your Account might be permanent or temporary.
          </p>
          <p>
            If your Account is closed or suspended for any reason, you must stop using
            your Card.
          </p>
          <p>
            You must also cancel all recurring charges or similar billing arrangements
            connected with the Account. We will not do this for you.
          </p>
          <p>
            If we close or permanently suspend your Account, you must also destroy all
            Cards.
          </p>
          <p>
            You must still pay us all amounts you owe on the Account, even if these
            amounts are charged after your Account is closed or suspended.
          </p>

          <h3>Additional Services</h3>
          <p>
            We may, from time to time, make additional services available to you directly
            or through affiliated or non-affiliated third parties.
          </p>
          <p>
            Without limitation, such services may include providing you with virtual
            accounts in order to enable you to use your Account or otherwise engage in
            various financial transactions that we do not directly provide.
          </p>
          <p>
            Each such service is subject to its own terms and conditions, and we shall not
            be responsible to you for any aspect of those services.
          </p>
          <p>
            We may permit you to charge any applicable fees for such services to your
            Account.
          </p>
          <p>
            You acknowledge and agree that we may receive compensation or otherwise
            benefit as a result of making such services available to you.
          </p>

          <h3>The Law that Applies to Your Agreement</h3>
          <p>This Agreement will be interpreted using Puerto Rican law.</p>
          <p>
            Federal law shall govern the Arbitration provisions of this Agreement, and
            as otherwise applicable.
          </p>
          <p>You waive any applicable statute of limitations, as the law allows.</p>
          <p>
            If any part of this Agreement is found to be unenforceable, the remaining
            parts will remain in effect.
          </p>

          <h3>Waiver</h3>
          <p>
            We will not lose any of our rights if we delay taking any action for any
            reason or if we do not notify you.
          </p>
          <p>
            For example, we may waive your fees or charges without notifying you and
            without losing our right to charge them in the future.
          </p>
          <p>
            We may always enforce our rights later and may take other actions not listed
            in this Agreement if the law allows them.
          </p>
          <p>
            You do not have to receive notice from us of any waiver, delay, demand or
            dishonor.
          </p>
          <p>We may proceed against you before proceeding against someone else.</p>

          <h3>Assignment</h3>
          <p>
            This Agreement will be binding on, and benefit, any of your and our
            successors and assigns.
          </p>
          <p>
            You may not transfer your Account or your Agreement to someone else without
            our written permission.
          </p>
          <p>
            We may transfer your Account, this Agreement, or any of our rights or
            obligations therein, to another company or person at any time, without your
            permission and without prior notice to you.
          </p>
          <p>If we do, they will take our place under this Agreement.</p>
          <p>
            You must pay them and perform all of your obligations to them and not us.
          </p>

          <h3>Dispute Resolution and Arbitration</h3>
          <div className={styles.importantNote}>
            <p>
              PLEASE READ THIS &ldquo;DISPUTE RESOLUTION AND ARBITRATION&rdquo; PROVISION
              VERY CAREFULLY. IT LIMITS YOUR RIGHTS IN THE EVENT OF A DISPUTE BETWEEN YOU
              AND ISSUER.
            </p>
            <p>
              YOU OR WE MAY ELECT TO RESOLVE ANY CLAIM BY INDIVIDUAL BINDING ARBITRATION.
            </p>
            <p>
              IF ARBITRATION IS CHOSEN BY ANY PARTY, NEITHER YOU NOR WE WILL HAVE THE
              RIGHT TO LITIGATE THAT CLAIM IN COURT OR HAVE A JURY TRIAL.
            </p>
            <p>
              DISCOVERY AND RIGHTS TO APPEAL IN ARBITRATION ARE GENERALLY MORE LIMITED
              THAN IN COURT.
            </p>
          </div>
          <p>This Arbitration provision shall be broadly interpreted and applies to:</p>
          <ul className={styles.legalList}>
            <li>
              claims arising out of or relating to any aspect of your relationship with
              us;
            </li>
            <li>
              claims arising out of or relating to this Agreement or prior agreements;
            </li>
            <li>
              claims regarding the applicability, enforceability or interpretation of
              this Arbitration provision; and
            </li>
            <li>claims that arose before this or any prior Agreement.</li>
          </ul>
          <p>
            The arbitration shall be administered by the American Arbitration Association
            (&ldquo;AAA&rdquo;) under its applicable rules.
          </p>
          <p>
            Arbitration shall proceed solely on an individual basis without the right for
            any claims to be arbitrated on a class action basis or on bases involving
            claims brought in a purported representative capacity on behalf of others.
          </p>
          <p>
            You agree that you may bring claims against us only in your individual
            capacity and not as a plaintiff or class member in any purported class or
            representative proceeding.
          </p>
          <p>
            If any court or arbitrator determines that the class action waiver set forth
            in this section is void or unenforceable for any reason, then the arbitration
            provision shall be deemed null and void in its entirety.
          </p>
          <p>
            This arbitration provision shall survive termination of your Account and
            this Agreement.
          </p>

          <h3>Limitation of Liability</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL ISSUER,
            ITS AFFILIATES, OR ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SERVICE
            PROVIDERS, OR LICENSORS BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL,
            CONSEQUENTIAL, SPECIAL, EXEMPLARY, PUNITIVE, OR OTHER SIMILAR DAMAGES, INCLUDING
            BUT NOT LIMITED TO LOST PROFITS, LOST REVENUE, LOST DATA, LOSS OF GOODWILL,
            BUSINESS INTERRUPTION, OR LOSS OF BUSINESS OPPORTUNITY, WHETHER ARISING IN
            CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE, EVEN IF ISSUER HAS
            BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
          <p>
            IN NO EVENT SHALL ISSUER&rsquo;S TOTAL LIABILITY TO YOU FOR ALL CLAIMS
            ARISING OUT OF OR RELATING TO THIS AGREEMENT OR YOUR ACCOUNT EXCEED THE LESSER
            OF:
          </p>
          <ul className={styles.legalList}>
            <li>(a) YOUR ACTUAL DIRECT DAMAGES PROVEN; OR</li>
            <li>
              (b) THE TOTAL AMOUNTS PAID BY YOU IN CONNECTION WITH THIS AGREEMENT IN THE
              TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM.
            </li>
          </ul>

          <h3>Indemnity</h3>
          <p>
            You will indemnify and defend Issuer, its affiliates, and its partners,
            directors, officers, employees, agents, trustees, administrators, managers,
            advisors, and representatives (each an &ldquo;Indemnitee&rdquo;) against, and
            hold each Indemnitee harmless from, any and all claims, litigation,
            investigations, proceedings, losses, damages, fines, penalties, liabilities,
            settlements, costs, fees, and expenses incurred by any Indemnitee or asserted
            against any Indemnitee by any person arising out of, in connection with,
            related to, or as a result of your:
          </p>
          <ul className={styles.legalList}>
            <li>
              (i) breach of any of the representations, warranties, or covenants contained
              in this Agreement; or
            </li>
            <li>
              (ii) gross negligence, fraud, or violation of any applicable law or rights of
              any third-party.
            </li>
          </ul>
          <p>
            Issuer may defend any claim subject to indemnification hereunder, using
            counsel of its choice, and you will pay or promptly reimburse Issuer for the
            reasonable fees of such counsel and all related costs and reasonable expenses.
          </p>

          <h3>Survival</h3>
          <p>
            The following provisions of this Agreement shall survive any termination or
            expiration of this Agreement and shall remain in full force and effect until
            all of your obligations to us have been fully and finally satisfied:
          </p>
          <ul className={styles.legalList}>
            <li>all payment obligations;</li>
            <li>all security interest and collateral provisions;</li>
            <li>indemnification obligations;</li>
            <li>limitation of liability provisions;</li>
            <li>arbitration provisions;</li>
            <li>communications provisions;</li>
            <li>governing law provisions;</li>
            <li>assignment rights; and</li>
            <li>any provision intended by its nature to survive termination.</li>
          </ul>

          <h3>Severability</h3>
          <p>
            If any provision of this Agreement is found to be invalid, illegal, or
            unenforceable, the remaining provisions shall remain in full force and effect.
          </p>

          <h3>Entire Agreement</h3>
          <p>
            This Agreement constitutes the entire agreement between you and Issuer
            regarding the subject matter hereof and supersedes all prior or contemporaneous
            agreements, understandings, representations, and communications whether
            written or oral.
          </p>
        </section>
      </div>
    </LegalLayout>
  );
};

export default IssuerInternationalPrivacyPolicy;
